import React, { FunctionComponent, useEffect, useState } from "react";
import { GameCodes } from "../type";
import SugarBlastUtils from "./sugar-blast/utils";
import SugarBlast2Utils from "./sugar-blast2/utils";
import CoinDozerUtils from "./coin-dozer/utils";
import VikingBlastUtils from "./viking-blast/utils";
import CleopatrasTreasureUtils from "./cleopatras-treasure/utils";
import RoosterBlitzUtils from "./rooster-blitz/utils";
import OlympusGloryUtils from "./olympus-glory/utils";
import PiratesTreasureUtils from "./pirates-treasure/utils";
import GoldRushBonanzaUtils from "./gold-rush-bonanza/utils";
import HippoSplashUtils from "./hippo-splash/utils";
import HunkCaiShenUtils from "./hunk-cai-shen/utils";
import ApiService from "../services/api-services";
import { CurrencySetting } from "../type";

const gameAndPayoutCalculation = [
  {
    gameCode: GameCodes.SugarBlast,
    maxPayoutFormular: SugarBlastUtils.maxPayoutFormular,
    maxBetFormular: SugarBlastUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.SugarBlast2,
    maxPayoutFormular: SugarBlast2Utils.maxPayoutFormular,
    maxBetFormular: SugarBlast2Utils.maxBetFormular,
  },
  {
    gameCode: GameCodes.CoinDozer,
    maxPayoutFormular: CoinDozerUtils.maxPayoutFormular,
    maxBetFormular: CoinDozerUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.VikingBlast,
    maxPayoutFormular: VikingBlastUtils.maxPayoutFormular,
    maxBetFormular: VikingBlastUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.CleopatrasTreasure,
    maxPayoutFormular: CleopatrasTreasureUtils.maxPayoutFormular,
    maxBetFormular: CleopatrasTreasureUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.RoosterBlitz,
    maxPayoutFormular: RoosterBlitzUtils.maxPayoutFormular,
    maxBetFormular: RoosterBlitzUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.OlympusGlory,
    maxPayoutFormular: OlympusGloryUtils.maxPayoutFormular,
    maxBetFormular: OlympusGloryUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.PiratesTreasure,
    maxPayoutFormular: PiratesTreasureUtils.maxPayoutFormular,
    maxBetFormular: PiratesTreasureUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.GoldRushBonanza,
    maxPayoutFormular: GoldRushBonanzaUtils.maxPayoutFormular,
    maxBetFormular: GoldRushBonanzaUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.HippoSplash,
    maxPayoutFormular: HippoSplashUtils.maxPayoutFormular,
    maxBetFormular: HippoSplashUtils.maxBetFormular,
  },
  {
    gameCode: GameCodes.HunkCaiShen,
    maxPayoutFormular: HunkCaiShenUtils.maxPayoutFormular,
    maxBetFormular: HunkCaiShenUtils.maxBetFormular,
  },
];

const header = `Game Code,Currency,Min Bet,Max Bet,Max Combined Payout,ChipOptions`;

export const MaxPayoutFormularView: FunctionComponent = () => {
  useEffect(() => {
    Promise.all(
      gameAndPayoutCalculation.map(async (s) => {
        const {
          data: { currencies = [] },
        } = (await ApiService.getSetting(s.gameCode).catch((e) => {
          console.error(e);
          return { data: { currencies: [] } };
        })) as {
          data: { currencies?: CurrencySetting[] };
        };
        return currencies
          .map((currency) => {
            const maxbet = Math.max(...currency.chipOptions);
            return `${s.gameCode},${currency.currency},${
              currency.minBet
            },${s.maxBetFormular(maxbet)},${s.maxPayoutFormular(
              maxbet
            )},"${currency.chipOptions.join(", ")}"`;
          })
          .join("\n");
      })
    ).then((settings) => {
      const csv = header + "\n" + settings.join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", "max-payout-formular.csv");
      a.textContent = "Download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }, []);
  return <></>;
};
